export default "__VITE_ASSET__f2f6222b__"